<template>
    <content-layout>
        <h1 slot="header">Sazināties</h1>

        <div class="row page-container">
            <div class="column small-12 large-8">
                <div class="page">

                    <template v-if="sent">
                        <p>Paldies! Tava ziņa ir nosūtīta.</p>
                        <button type="button" class="button default" @click="reset()">Sūtīt jaunu ziņu</button>
                    </template>

                    <form v-else @submit.prevent="send()">

                        <div class="row">
                            <label class="small-12 large-6 column" :class="{ 'is-invalid-label': errors.has('first_name') }">Vārds
                                <input type="text" v-model="form.first_name" v-validate="'required|max:250'" name="first_name" id="first_name"/>
                                <span class="form-error is-visible" v-if="errors.has('first_name')">{{ errors.first('first_name') }}</span>
                            </label>

                            <label class="small-12 large-6 column" :class="{ 'is-invalid-label': errors.has('last_name') }">Uzvārds
                                <input type="text" v-model="form.last_name" v-validate="'required|max:250'" name="last_name" id="last_name"/>
                                <span class="form-error is-visible" v-if="errors.has('last_name')">{{ errors.first('last_name') }}</span>
                            </label>
                        </div>

                        <div class="row">
                            <label class="small-12 large-6 column" :class="{ 'is-invalid-label': errors.has('email') }">E-pasts
                                <input type="text" v-model="form.email" v-validate="'required|email'" name="email" id="email"/>
                                <span class="form-error is-visible" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                            </label>

                            <label class="small-12 large-6 column" :class="{ 'is-invalid-label': errors.has('topic') }">Tēma
                                <input type="text" v-model="form.topic" v-validate="'required|max:250'" name="topic" id="topic"/>
                                <span class="form-error is-visible" v-if="errors.has('topic')">{{ errors.first('topic') }}</span>
                            </label>
                        </div>

                        <div class="row column">
                            <label :class="{ 'is-invalid-label': errors.has('message') }">Tava ziņa
                                <textarea v-model="form.message" name="message" id="message" :class="{ 'is-invalid-input': errors.has('message') }" v-validate="'max:1000'" rows="4"></textarea>
                                <div class="text-right note">Atlikušo simbolu skaits: {{ form.message ? 1000 - form.message.length : 1000}}</div>
                                <span class="form-error is-visible" v-if="errors.has('message')">{{ errors.first('message') }}</span>
                            </label>
                        </div>

                        <div class="row column">
                            <vue-recaptcha sitekey="6Lf_GkIUAAAAAN9Y4tcJzkD9Y_ItR5_9Al7exitC" class="form-element" @verify="setRecaptchaResponse($event)"></vue-recaptcha>
                            <span class="form-error is-visible" v-if="errors.has('g_recaptcha_response')">{{ errors.first('g_recaptcha_response') }}</span>
                        </div>

                        <button type="submit" class="button primary">Sūtīt</button>

                    </form>
                </div>
            </div>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../../layouts/ContentLayout'
    import VueRecaptcha from 'vue-recaptcha'
    import { Form } from '../../modules/forms/Form'
    import contact from '../../api/contact'

    export default {
        data() {
            return {
                form: new Form({
                    'first_name': null,
                    'last_name': null,
                    'email': null,
                    'topic': null,
                    'message': null,
                    'g_recaptcha_response': null,
                }),

                sending: false,

                sent: false,
            }
        },

        created() {
            if (typeof(grecaptcha) === 'undefined') {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = 'https://www.google.com/recaptcha/api.js' +
                    '?onload=vueRecaptchaApiLoaded&render=explicit&hl=lv';

                document.body.appendChild(script);
            }
        },

        methods: {
            send() {
                this.$validator.validateAll().then(result =>{
                    if (result) {
                        this.sending = true;
                        contact.send(this.form.data())
                            .then(response => {
                                this.sending = false
                                this.sent = true
                            }, response => {
                                this.sending = false
                                const errors = response.data.errors;

                                // Record errors for available fields only
                                for (let field in errors) {
                                    if (!errors.hasOwnProperty(field)) continue;

                                    if (this.form.hasOwnProperty(field)) {
                                        this.errors.add(field, errors[field][0], 'contact')
                                    }
                                }
                            })
                            .catch(error => {
                                this.sending = false
                                throw error;
                            })
                    }
                })
            },

            setRecaptchaResponse(response) {
                this.form.g_recaptcha_response = response;
            },

            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))
            }
        },


        components: {
            ContentLayout, VueRecaptcha
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/pages/Contact.vue